const MAX_DEPTH = 3;
const MAX_KEYS = 20;
const MAX_STRING_LENGTH = 200;

function isSensitiveKey(key: string): boolean {
  const lower = key.toLowerCase();
  return (
    lower.includes('token') ||
    lower.includes('password') ||
    lower.includes('authorization') ||
    lower.includes('cookie') ||
    lower.includes('signature') ||
    lower.includes('secret') ||
    lower.includes('credential')
  );
}

function sanitizeValue(value: unknown, depth: number): unknown {
  if (value === null || value === undefined) {
    return value;
  }

  if (depth >= MAX_DEPTH) {
    return '[truncated]';
  }

  if (typeof value === 'string') {
    return value.length > MAX_STRING_LENGTH ? `${value.slice(0, MAX_STRING_LENGTH)}...` : value;
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    return value;
  }

  if (value instanceof Error) {
    return {
      name: value.name,
      message: value.message,
    };
  }

  if (Array.isArray(value)) {
    const result: unknown[] = [];
    const limit = Math.min(value.length, MAX_KEYS);
    for (let i = 0; i < limit; i += 1) {
      result.push(sanitizeValue(value[i], depth + 1));
    }
    if (value.length > MAX_KEYS) {
      result.push('[truncated]');
    }
    return result;
  }

  if (typeof value === 'object') {
    const objectValue = value as Record<string, unknown>;
    const entries = Object.entries(objectValue);
    const sanitized: Record<string, unknown> = {};
    const limit = Math.min(entries.length, MAX_KEYS);

    for (let i = 0; i < limit; i += 1) {
      const [key, entryValue] = entries[i];
      sanitized[key] = isSensitiveKey(key) ? '[redacted]' : sanitizeValue(entryValue, depth + 1);
    }

    if (entries.length > MAX_KEYS) {
      sanitized.__truncated__ = true;
    }

    return sanitized;
  }

  return String(value);
}

export function sanitizeLogArgs(args: unknown[]): unknown[] {
  if (!args.length) {
    return [];
  }

  return args.map((arg) => sanitizeValue(arg, 0));
}
